angular.module('manufacturing')
    .controller('ManufacturingOrderEditController', function ($scope, $rootScope, $uibModalInstance, ManufacturingOrder, data, ManufacturingOrderService, ManufacturingOrderAcceptanceService, ManufacturingOrderVehicleConflictService, Product, Client) {
        this.linkToOrderId = data.linkToOrderId
        let vehicleConflictRequest = 0

        this.$onInit = () => {
            if (data.id != null) {
                ManufacturingOrder.get({id: data.id}).$promise
                    .then(item => {
                        this.item = item
                        this.order = angular.copy(item)
                        if(data.properties != null){
                            angular.extend(this.item, data.properties)
                        }
                        this.loadLocation(this.item.location.id)
                        this.loadTransportLocation()
                        this.loadClient(this.item.client.id)
                        this.checkVehicleConflict()
                    })
                    .then(() => {
                        this.clientStatusAcceptanceRequired = this.item.client.status !== 'ACTIVE'
                        delete this.item.clientStatusAcceptance
                    })
            } else {
                this.item = {
                    status: "PENDING"
                }
                if(data.properties != null){
                    angular.extend(this.item, data.properties)
                }
                if(this.item.location != null)
                    this.loadLocation(this.item.location.id)

                this.loadTransportLocation()

                if(this.item.client != null){
                    this.loadClient(this.item.client.id)
                    this.clientStatusAcceptanceRequired = this.item.client.status !== 'ACTIVE'
                }
                delete this.item.clientStatusAcceptance

            }
            $scope.$watch('$ctrl.item.deliveryTime', (deliveryTime, previousDeliveryTime) => {
                if (deliveryTime !== previousDeliveryTime) this.checkVehicleConflict()
            })
        }

        this.loadClient = (clientId) => {
            if (clientId == null){
                this.client = null
                return
            }

            Client.get({id: clientId}).$promise.then(client => this.client = client);
        }

        this.onClientChanged = () => {
            delete this.item.clientStatusAcceptance
            this.clientStatusAcceptanceRequired = this.item.client != null? this.item.client.status !== 'ACTIVE' : false
            let clientId = this.item.client != null ? this.item.client.id : null
            this.loadClient(clientId)
        }
        this.onClientStatusAcceptanceChanged = () => {
            if(this.item.clientStatusAcceptance.confirmation === true){
                this.item.clientStatusAcceptance.status = this.item.client.status
            }
            else {
                delete this.item.clientStatusAcceptance.status
            }
        }

        this.onLocationChanged = () => {
            delete this.item.nodes
            if(this.item.location == null){
                this.item.locationAcceptance = null
                this.canChangeLocationAcceptance = null
            }
            else {
                this.loadLocation(this.item.location.id)
            }
            this.reloadTransportLocationAcceptance()
        }

        this.loadLocation = (locationId) => {
            return ManufacturingOrderAcceptanceService.location(locationId).then(context => {
                this.canChangeLocationAcceptance = context.canChange
                this.item.locationAcceptance = context.acceptance
            })
        }

        this.toggleLocationAcceptance = () => {
            if(this.item.locationAcceptance == null){
                this.item.locationAcceptance = {
                    required: true,
                    status: 'PENDING'
                }
            }
            else {
                if(this.canChangeLocationAcceptance === true){
                    this.item.locationAcceptance = null
                }
                else {
                    this.item.locationAcceptance.status = this.item.locationAcceptance.status === 'PENDING' ? 'ACCEPTED' : 'PENDING'
                }
            }
        }
        this.toggleTransportAcceptance = () => {
            if(this.item.transportAcceptance == null) {
                this.item.transportAcceptance = {
                    required: true,
                    status: 'PENDING'
                }
            }
            else {
                this.item.transportAcceptance.status = this.item.transportAcceptance.status === 'PENDING' ? 'ACCEPTED' : 'PENDING'
            }
        }

        this.refreshProducts = q => Product.autocomplete(q, 100).then(items => this.products = items);

        this.toggleExternalTransport = () => {
            if (this.item.transport == null || this.item.transport.externalVehicle == null || this.item.transport.externalVehicle === false) {
                this.item.transport = {externalVehicle: true}
                this.onTransportVehicleChanged()
                return
            }
            delete this.item.transport
            this.onTransportVehicleChanged()
        }

        this.reloadTransportLocationAcceptance = () => {
            this.item.transportAcceptance = ManufacturingOrderAcceptanceService.transportAcceptance(this.item.location && this.item.location.id, this.transportContext)
        }

        this.loadTransportLocation = () => {
            return ManufacturingOrderAcceptanceService.transport(this.item.transport).then(context => {
                this.transportContext = context
                this.canChangeTransportAcceptance = context.canChange
                this.reloadTransportLocationAcceptance()
            })
        }
        this.onTransportVehicleChanged = () => {
            this.loadTransportLocation()
            this.checkVehicleConflict()
        }

        this.checkVehicleConflict = () => {
            const request = ++vehicleConflictRequest
            this.vehicleConflict = null
            if (!this.hasScheduleChanged()) return
            const vehicle = this.item && this.item.transport && !this.item.transport.externalVehicle ? this.item.transport.vehicle : null
            ManufacturingOrderVehicleConflictService.check(vehicle, this.item && this.item.deliveryTime, this.item && this.item.id).then(conflict => {
                if (request === vehicleConflictRequest) this.vehicleConflict = conflict
            })
        }

        this.hasScheduleChanged = () => {
            if (!this.order) return true
            const currentVehicleId = this.item && this.item.transport && this.item.transport.vehicle && this.item.transport.vehicle.id
            const originalVehicleId = this.order.transport && this.order.transport.vehicle && this.order.transport.vehicle.id
            return currentVehicleId !== originalVehicleId || !moment(this.item.deliveryTime).isSame(this.order.deliveryTime)
        }

        this.checkIfTransportAcceptanceRequired = () => {
            // this.item.transport == null || this.item.transport.externalVehicle === true || this.item.transport.ve
        }

        this.openBatch = () => ManufacturingOrderService.addBatch(angular.copy(this.item)).then(() => $uibModalInstance.close(), angular.noop)

        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = ManufacturingOrder.update(this.item).$promise
            } else {
                promise = ManufacturingOrder.save({linkToOrderId: this.linkToOrderId}, this.item).$promise
            }
            return promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast('manufacturing-order.updated')
            })
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
